import firestore from "firebase/firestore";

export enum GameStatus {
  "WAIT_FOR_MEMBERS",
  "WAIT_FOR_INVENTED_NAME",
  "PLAY",
}

export type Member = {
  userId: string;
  displayName?: string;
  solved?: boolean;
  solvedTimestamp?: firestore.Timestamp;
  inventedUserId?: number;
  inventedName?: string;
};
export type Game = {
  masterUserId: string;
  activePlayerId: null | string;
  status: GameStatus;
  membersMap: Record<string, Member>;
};
